// extracted by mini-css-extract-plugin
export default {"Header":"Intro_Header__FGo3p","Text":"Intro_Text__2KlAA"};